import { BOOST_IDS, BOOST_TICKS, type BoostId } from '../sim/boosts';

/** Content-side boost definition: shop data for the sim's one-use boosts (src/sim/boosts.ts). */
export interface BoostDef {
  id: BoostId;
  name: string;
  /** HUD button label. */
  short: string;
  /** What it does, in a few words (shop showcase). */
  blurb: string;
  /** Coins per boost. */
  price: number;
  /** Campaign lawn that must be cleared before the shop sells it. */
  unlockLevel: number;
}

const seconds = (id: BoostId) => BOOST_TICKS[id] / 60;

/** The boost catalog, in shop order. Prices are tuning starting points (docs/PLAYTEST.md). */
export const BOOSTS: readonly BoostDef[] = [
  {
    id: 'shield',
    name: 'Shield',
    short: 'SHLD',
    blurb: `No hearts lost for ${seconds('shield')}s.`,
    price: 30,
    unlockLevel: 12,
  },
  {
    id: 'turbo',
    name: 'Turbo',
    short: 'TRBO',
    blurb: `Speed burst for ${seconds('turbo')}s.`,
    price: 25,
    unlockLevel: 20,
  },
  {
    id: 'treat',
    name: 'Critter Treat',
    short: 'TRT',
    blurb: `Critters munch and stay put, ${seconds('treat')}s.`,
    price: 20,
    unlockLevel: 28,
  },
  {
    id: 'magnet',
    name: 'Coin Magnet',
    short: 'MAG',
    blurb: `Pulls in coins near you, ${seconds('magnet')}s.`,
    price: 35,
    unlockLevel: 35,
  },
];

export const BOOST_BY_ID: Readonly<Record<BoostId, BoostDef>> = Object.fromEntries(
  BOOSTS.map((b) => [b.id, b]),
) as Record<BoostId, BoostDef>;

/** Most of one boost a player can hold. */
export const MAX_BOOST_STOCK = 9;

export { BOOST_IDS, type BoostId };
